"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var DOMException = require("domexception/webidl2js-wrapper");

var EventTargetImpl = require("../events/EventTarget-impl").implementation;

var _require = require("../../utils"),
    simultaneousIterators = _require.simultaneousIterators;

var NODE_TYPE = require("../node-type");

var NODE_DOCUMENT_POSITION = require("../node-document-position");

var _require2 = require("../node"),
    clone = _require2.clone,
    locateNamespacePrefix = _require2.locateNamespacePrefix,
    locateNamespace = _require2.locateNamespace;

var _require3 = require("../attributes"),
    setAnExistingAttributeValue = _require3.setAnExistingAttributeValue;

var NodeList = require("../generated/NodeList");

var _require4 = require("../helpers/node"),
    nodeRoot = _require4.nodeRoot,
    nodeLength = _require4.nodeLength;

var _require5 = require("../helpers/internal-constants"),
    domSymbolTree = _require5.domSymbolTree;

var _require6 = require("../helpers/document-base-url"),
    documentBaseURLSerialized = _require6.documentBaseURLSerialized;

var _require7 = require("../helpers/mutation-observers"),
    queueTreeMutationRecord = _require7.queueTreeMutationRecord;

var _require8 = require("../helpers/custom-elements"),
    enqueueCECallbackReaction = _require8.enqueueCECallbackReaction,
    tryUpgradeElement = _require8.tryUpgradeElement;

var _require9 = require("../helpers/shadow-dom"),
    isShadowRoot = _require9.isShadowRoot,
    shadowIncludingRoot = _require9.shadowIncludingRoot,
    assignSlot = _require9.assignSlot,
    assignSlotableForTree = _require9.assignSlotableForTree,
    assignSlotable = _require9.assignSlotable,
    signalSlotChange = _require9.signalSlotChange,
    isSlot = _require9.isSlot,
    shadowIncludingInclusiveDescendantsIterator = _require9.shadowIncludingInclusiveDescendantsIterator,
    shadowIncludingDescendantsIterator = _require9.shadowIncludingDescendantsIterator;

function isObsoleteNodeType(node) {
  return node.nodeType === NODE_TYPE.ENTITY_NODE || node.nodeType === NODE_TYPE.ENTITY_REFERENCE_NODE || node.nodeType === NODE_TYPE.NOTATION_NODE || node.nodeType === NODE_TYPE.CDATA_SECTION_NODE;
}

function nodeEquals(a, b) {
  if (a.nodeType !== b.nodeType) {
    return false;
  }

  switch (a.nodeType) {
    case NODE_TYPE.DOCUMENT_TYPE_NODE:
      if (a.name !== b.name || a.publicId !== b.publicId || a.systemId !== b.systemId) {
        return false;
      }

      break;

    case NODE_TYPE.ELEMENT_NODE:
      if (a._namespaceURI !== b._namespaceURI || a._prefix !== b._prefix || a._localName !== b._localName || a._attributes.length !== b._attributes.length) {
        return false;
      }

      break;

    case NODE_TYPE.ATTRIBUTE_NODE:
      if (a._namespace !== b._namespace || a._localName !== b._localName || a._value !== b._value) {
        return false;
      }

      break;

    case NODE_TYPE.PROCESSING_INSTRUCTION_NODE:
      if (a._target !== b._target || a._data !== b._data) {
        return false;
      }

      break;

    case NODE_TYPE.TEXT_NODE:
    case NODE_TYPE.COMMENT_NODE:
      if (a._data !== b._data) {
        return false;
      }

      break;
  }

  if (a.nodeType === NODE_TYPE.ELEMENT_NODE && !attributeListsEqual(a, b)) {
    return false;
  }

  var _iterator = _createForOfIteratorHelper(simultaneousIterators(domSymbolTree.childrenIterator(a), domSymbolTree.childrenIterator(b))),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var nodes = _step.value;

      if (!nodes[0] || !nodes[1]) {
        // mismatch in the amount of childNodes
        return false;
      }

      if (!nodeEquals(nodes[0], nodes[1])) {
        return false;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return true;
} // Needed by https://dom.spec.whatwg.org/#concept-node-equals


function attributeListsEqual(elementA, elementB) {
  var listA = elementA._attributeList;
  var listB = elementB._attributeList;
  var lengthA = listA.length;
  var lengthB = listB.length;

  if (lengthA !== lengthB) {
    return false;
  }

  var _loop = function _loop(i) {
    var attrA = listA[i];

    if (!listB.some(function (attrB) {
      return nodeEquals(attrA, attrB);
    })) {
      return {
        v: false
      };
    }
  };

  for (var i = 0; i < lengthA; ++i) {
    var _ret = _loop(i);

    if (_typeof(_ret) === "object") return _ret.v;
  }

  return true;
} // https://dom.spec.whatwg.org/#concept-tree-host-including-inclusive-ancestor


function isHostInclusiveAncestor(nodeImplA, nodeImplB) {
  var _iterator2 = _createForOfIteratorHelper(domSymbolTree.ancestorsIterator(nodeImplB)),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var ancestor = _step2.value;

      if (ancestor === nodeImplA) {
        return true;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  var rootImplB = nodeRoot(nodeImplB);

  if (rootImplB._host) {
    return isHostInclusiveAncestor(nodeImplA, rootImplB._host);
  }

  return false;
}

var NodeImpl = /*#__PURE__*/function (_EventTargetImpl) {
  _inherits(NodeImpl, _EventTargetImpl);

  var _super = _createSuper(NodeImpl);

  function NodeImpl(globalObject, args, privateData) {
    var _this;

    _classCallCheck(this, NodeImpl);

    _this = _super.call(this, globalObject, args, privateData);
    domSymbolTree.initialize(_assertThisInitialized(_this));
    _this._ownerDocument = privateData.ownerDocument;
    _this._childNodesList = null;
    _this._childrenList = null;
    _this._version = 0;
    _this._memoizedQueries = {};
    _this._registeredObserverList = [];
    _this._referencedRanges = new Set();
    return _this;
  }

  _createClass(NodeImpl, [{
    key: "_getTheParent",
    value: function _getTheParent() {
      if (this._assignedSlot) {
        return this._assignedSlot;
      }

      return domSymbolTree.parent(this);
    }
  }, {
    key: "parentNode",
    get: function get() {
      return domSymbolTree.parent(this);
    }
  }, {
    key: "getRootNode",
    value: function getRootNode(options) {
      return options.composed ? shadowIncludingRoot(this) : nodeRoot(this);
    }
  }, {
    key: "nodeName",
    get: function get() {
      switch (this.nodeType) {
        case NODE_TYPE.ELEMENT_NODE:
          return this.tagName;

        case NODE_TYPE.ATTRIBUTE_NODE:
          return this._qualifiedName;

        case NODE_TYPE.TEXT_NODE:
          return "#text";

        case NODE_TYPE.CDATA_SECTION_NODE:
          return "#cdata-section";

        case NODE_TYPE.PROCESSING_INSTRUCTION_NODE:
          return this.target;

        case NODE_TYPE.COMMENT_NODE:
          return "#comment";

        case NODE_TYPE.DOCUMENT_NODE:
          return "#document";

        case NODE_TYPE.DOCUMENT_TYPE_NODE:
          return this.name;

        case NODE_TYPE.DOCUMENT_FRAGMENT_NODE:
          return "#document-fragment";
      } // should never happen


      return null;
    }
  }, {
    key: "firstChild",
    get: function get() {
      return domSymbolTree.firstChild(this);
    } // https://dom.spec.whatwg.org/#connected
    // https://dom.spec.whatwg.org/#dom-node-isconnected

  }, {
    key: "isConnected",
    get: function get() {
      var root = shadowIncludingRoot(this);
      return root && root.nodeType === NODE_TYPE.DOCUMENT_NODE;
    }
  }, {
    key: "ownerDocument",
    get: function get() {
      return this.nodeType === NODE_TYPE.DOCUMENT_NODE ? null : this._ownerDocument;
    }
  }, {
    key: "lastChild",
    get: function get() {
      return domSymbolTree.lastChild(this);
    }
  }, {
    key: "childNodes",
    get: function get() {
      var _this2 = this;

      if (!this._childNodesList) {
        this._childNodesList = NodeList.createImpl(this._globalObject, [], {
          element: this,
          query: function query() {
            return domSymbolTree.childrenToArray(_this2);
          }
        });
      } else {
        this._childNodesList._update();
      }

      return this._childNodesList;
    }
  }, {
    key: "nextSibling",
    get: function get() {
      return domSymbolTree.nextSibling(this);
    }
  }, {
    key: "previousSibling",
    get: function get() {
      return domSymbolTree.previousSibling(this);
    }
  }, {
    key: "_modified",
    value: function _modified() {
      this._version++;

      var _iterator3 = _createForOfIteratorHelper(domSymbolTree.ancestorsIterator(this)),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var ancestor = _step3.value;
          ancestor._version++;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      if (this._childrenList) {
        this._childrenList._update();
      }

      if (this._childNodesList) {
        this._childNodesList._update();
      }

      this._clearMemoizedQueries();
    }
  }, {
    key: "_childTextContentChangeSteps",
    value: function _childTextContentChangeSteps() {// Default: do nothing
    }
  }, {
    key: "_clearMemoizedQueries",
    value: function _clearMemoizedQueries() {
      this._memoizedQueries = {};
      var myParent = domSymbolTree.parent(this);

      if (myParent) {
        myParent._clearMemoizedQueries();
      }
    }
  }, {
    key: "_descendantRemoved",
    value: function _descendantRemoved(parent, child) {
      var myParent = domSymbolTree.parent(this);

      if (myParent) {
        myParent._descendantRemoved(parent, child);
      }
    }
  }, {
    key: "_descendantAdded",
    value: function _descendantAdded(parent, child) {
      var myParent = domSymbolTree.parent(this);

      if (myParent) {
        myParent._descendantAdded(parent, child);
      }
    }
  }, {
    key: "_attach",
    value: function _attach() {
      this._attached = true;

      var _iterator4 = _createForOfIteratorHelper(domSymbolTree.childrenIterator(this)),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var child = _step4.value;

          if (child._attach) {
            child._attach();
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this._attached = false;

      if (this._ownerDocument && this._ownerDocument._lastFocusedElement === this) {
        this._ownerDocument._lastFocusedElement = null;
      }

      var _iterator5 = _createForOfIteratorHelper(domSymbolTree.childrenIterator(this)),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var child = _step5.value;

          if (child._detach) {
            child._detach();
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  }, {
    key: "hasChildNodes",
    value: function hasChildNodes() {
      return domSymbolTree.hasChildren(this);
    } // https://dom.spec.whatwg.org/#dom-node-normalize

  }, {
    key: "normalize",
    value: function normalize() {
      // It is important to use a treeToArray instead of a treeToIterator here, because the
      // treeToIterator doesn't support tree mutation in the middle of the traversal.
      var _iterator6 = _createForOfIteratorHelper(domSymbolTree.treeToArray(this)),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var node = _step6.value;
          var parentNode = domSymbolTree.parent(node);

          if (parentNode === null || node.nodeType !== NODE_TYPE.TEXT_NODE) {
            continue;
          }

          var length = nodeLength(node);

          if (length === 0) {
            parentNode._remove(node);

            continue;
          }

          var continuousExclusiveTextNodes = [];

          var _iterator7 = _createForOfIteratorHelper(domSymbolTree.previousSiblingsIterator(node)),
              _step7;

          try {
            for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
              var _currentNode = _step7.value;

              if (_currentNode.nodeType !== NODE_TYPE.TEXT_NODE) {
                break;
              }

              continuousExclusiveTextNodes.unshift(_currentNode);
            }
          } catch (err) {
            _iterator7.e(err);
          } finally {
            _iterator7.f();
          }

          var _iterator8 = _createForOfIteratorHelper(domSymbolTree.nextSiblingsIterator(node)),
              _step8;

          try {
            for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
              var _currentNode2 = _step8.value;

              if (_currentNode2.nodeType !== NODE_TYPE.TEXT_NODE) {
                break;
              }

              continuousExclusiveTextNodes.push(_currentNode2);
            }
          } catch (err) {
            _iterator8.e(err);
          } finally {
            _iterator8.f();
          }

          var data = continuousExclusiveTextNodes.reduce(function (d, n) {
            return d + n._data;
          }, "");
          node.replaceData(length, 0, data);
          var currentNode = domSymbolTree.nextSibling(node);

          while (currentNode && currentNode.nodeType !== NODE_TYPE.TEXT_NODE) {
            var currentNodeParent = domSymbolTree.parent(currentNode);
            var currentNodeIndex = domSymbolTree.index(currentNode);

            var _iterator9 = _createForOfIteratorHelper(node._referencedRanges),
                _step9;

            try {
              for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                var range = _step9.value;
                var _start = range._start,
                    _end = range._end;

                if (_start.node === currentNode) {
                  range._setLiveRangeStart(node, _start.offset + length);
                }

                if (_end.node === currentNode) {
                  range._setLiveRangeEnd(node, _end.offset + length);
                }

                if (_start.node === currentNodeParent && _start.offset === currentNodeIndex) {
                  range._setLiveRangeStart(node, length);
                }

                if (_end.node === currentNodeParent && _end.offset === currentNodeIndex) {
                  range._setLiveRangeStart(node, length);
                }
              }
            } catch (err) {
              _iterator9.e(err);
            } finally {
              _iterator9.f();
            }

            length += nodeLength(currentNode);
            currentNode = domSymbolTree.nextSibling(currentNode);
          }

          for (var _i = 0, _continuousExclusiveT = continuousExclusiveTextNodes; _i < _continuousExclusiveT.length; _i++) {
            var continuousExclusiveTextNode = _continuousExclusiveT[_i];

            parentNode._remove(continuousExclusiveTextNode);
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
    }
  }, {
    key: "parentElement",
    get: function get() {
      var parentNode = domSymbolTree.parent(this);
      return parentNode !== null && parentNode.nodeType === NODE_TYPE.ELEMENT_NODE ? parentNode : null;
    }
  }, {
    key: "baseURI",
    get: function get() {
      return documentBaseURLSerialized(this._ownerDocument);
    }
  }, {
    key: "compareDocumentPosition",
    value: function compareDocumentPosition(other) {
      // Let node1 be other and node2 be the context object.
      var node1 = other;
      var node2 = this;

      if (isObsoleteNodeType(node2) || isObsoleteNodeType(node1)) {
        throw new Error("Obsolete node type");
      }

      var attr1 = null;
      var attr2 = null;

      if (node1.nodeType === NODE_TYPE.ATTRIBUTE_NODE) {
        attr1 = node1;
        node1 = attr1._element;
      }

      if (node2.nodeType === NODE_TYPE.ATTRIBUTE_NODE) {
        attr2 = node2;
        node2 = attr2._element;

        if (attr1 !== null && node1 !== null && node2 === node1) {
          var _iterator10 = _createForOfIteratorHelper(node2._attributeList),
              _step10;

          try {
            for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
              var attr = _step10.value;

              if (nodeEquals(attr, attr1)) {
                return NODE_DOCUMENT_POSITION.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC | NODE_DOCUMENT_POSITION.DOCUMENT_POSITION_PRECEDING;
              }

              if (nodeEquals(attr, attr2)) {
                return NODE_DOCUMENT_POSITION.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC | NODE_DOCUMENT_POSITION.DOCUMENT_POSITION_FOLLOWING;
              }
            }
          } catch (err) {
            _iterator10.e(err);
          } finally {
            _iterator10.f();
          }
        }
      }

      var result = domSymbolTree.compareTreePosition(node2, node1); // “If other and reference are not in the same tree, return the result of adding DOCUMENT_POSITION_DISCONNECTED,
      //  DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC, and either DOCUMENT_POSITION_PRECEDING or
      // DOCUMENT_POSITION_FOLLOWING, with the constraint that this is to be consistent, together.”

      if (result === NODE_DOCUMENT_POSITION.DOCUMENT_POSITION_DISCONNECTED) {
        // symbol-tree does not add these bits required by the spec:
        return NODE_DOCUMENT_POSITION.DOCUMENT_POSITION_DISCONNECTED | NODE_DOCUMENT_POSITION.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC | NODE_DOCUMENT_POSITION.DOCUMENT_POSITION_FOLLOWING;
      }

      return result;
    }
  }, {
    key: "lookupPrefix",
    value: function lookupPrefix(namespace) {
      if (namespace === null || namespace === "") {
        return null;
      }

      switch (this.nodeType) {
        case NODE_TYPE.ELEMENT_NODE:
          {
            return locateNamespacePrefix(this, namespace);
          }

        case NODE_TYPE.DOCUMENT_NODE:
          {
            return this.documentElement !== null ? locateNamespacePrefix(this.documentElement, namespace) : null;
          }

        case NODE_TYPE.DOCUMENT_TYPE_NODE:
        case NODE_TYPE.DOCUMENT_FRAGMENT_NODE:
          {
            return null;
          }

        case NODE_TYPE.ATTRIBUTE_NODE:
          {
            return this._element !== null ? locateNamespacePrefix(this._element, namespace) : null;
          }

        default:
          {
            return this.parentElement !== null ? locateNamespacePrefix(this.parentElement, namespace) : null;
          }
      }
    }
  }, {
    key: "lookupNamespaceURI",
    value: function lookupNamespaceURI(prefix) {
      if (prefix === "") {
        prefix = null;
      }

      return locateNamespace(this, prefix);
    }
  }, {
    key: "isDefaultNamespace",
    value: function isDefaultNamespace(namespace) {
      if (namespace === "") {
        namespace = null;
      }

      var defaultNamespace = locateNamespace(this, null);
      return defaultNamespace === namespace;
    }
  }, {
    key: "contains",
    value: function contains(other) {
      if (other === null) {
        return false;
      } else if (this === other) {
        return true;
      }

      return Boolean(this.compareDocumentPosition(other) & NODE_DOCUMENT_POSITION.DOCUMENT_POSITION_CONTAINED_BY);
    }
  }, {
    key: "isEqualNode",
    value: function isEqualNode(node) {
      if (node === null) {
        return false;
      } // Fast-path, not in the spec


      if (this === node) {
        return true;
      }

      return nodeEquals(this, node);
    }
  }, {
    key: "isSameNode",
    value: function isSameNode(node) {
      if (this === node) {
        return true;
      }

      return false;
    }
  }, {
    key: "cloneNode",
    value: function cloneNode(deep) {
      if (isShadowRoot(this)) {
        throw DOMException.create(this._globalObject, ["ShadowRoot nodes are not clonable.", "NotSupportedError"]);
      }

      deep = Boolean(deep);
      return clone(this, undefined, deep);
    }
  }, {
    key: "nodeValue",
    get: function get() {
      switch (this.nodeType) {
        case NODE_TYPE.ATTRIBUTE_NODE:
          {
            return this._value;
          }

        case NODE_TYPE.TEXT_NODE:
        case NODE_TYPE.CDATA_SECTION_NODE: // CDATASection is a subclass of Text

        case NODE_TYPE.PROCESSING_INSTRUCTION_NODE:
        case NODE_TYPE.COMMENT_NODE:
          {
            return this._data;
          }

        default:
          {
            return null;
          }
      }
    },
    set: function set(value) {
      if (value === null) {
        value = "";
      }

      switch (this.nodeType) {
        case NODE_TYPE.ATTRIBUTE_NODE:
          {
            setAnExistingAttributeValue(this, value);
            break;
          }

        case NODE_TYPE.TEXT_NODE:
        case NODE_TYPE.CDATA_SECTION_NODE: // CDATASection is a subclass of Text

        case NODE_TYPE.PROCESSING_INSTRUCTION_NODE:
        case NODE_TYPE.COMMENT_NODE:
          {
            this.replaceData(0, this.length, value);
            break;
          }
      }
    } // https://dom.spec.whatwg.org/#dom-node-textcontent

  }, {
    key: "textContent",
    get: function get() {
      switch (this.nodeType) {
        case NODE_TYPE.DOCUMENT_FRAGMENT_NODE:
        case NODE_TYPE.ELEMENT_NODE:
          {
            var text = "";

            var _iterator11 = _createForOfIteratorHelper(domSymbolTree.treeIterator(this)),
                _step11;

            try {
              for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
                var child = _step11.value;

                if (child.nodeType === NODE_TYPE.TEXT_NODE || child.nodeType === NODE_TYPE.CDATA_SECTION_NODE) {
                  text += child.nodeValue;
                }
              }
            } catch (err) {
              _iterator11.e(err);
            } finally {
              _iterator11.f();
            }

            return text;
          }

        case NODE_TYPE.ATTRIBUTE_NODE:
          {
            return this._value;
          }

        case NODE_TYPE.TEXT_NODE:
        case NODE_TYPE.CDATA_SECTION_NODE: // CDATASection is a subclass of Text

        case NODE_TYPE.PROCESSING_INSTRUCTION_NODE:
        case NODE_TYPE.COMMENT_NODE:
          {
            return this._data;
          }

        default:
          {
            return null;
          }
      }
    },
    set: function set(value) {
      if (value === null) {
        value = "";
      }

      switch (this.nodeType) {
        case NODE_TYPE.DOCUMENT_FRAGMENT_NODE:
        case NODE_TYPE.ELEMENT_NODE:
          {
            // https://dom.spec.whatwg.org/#string-replace-all
            var nodeImpl = null;

            if (value !== "") {
              nodeImpl = this._ownerDocument.createTextNode(value);
            }

            this._replaceAll(nodeImpl);

            break;
          }

        case NODE_TYPE.ATTRIBUTE_NODE:
          {
            setAnExistingAttributeValue(this, value);
            break;
          }

        case NODE_TYPE.TEXT_NODE:
        case NODE_TYPE.CDATA_SECTION_NODE: // CDATASection is a subclass of Text

        case NODE_TYPE.PROCESSING_INSTRUCTION_NODE:
        case NODE_TYPE.COMMENT_NODE:
          {
            this.replaceData(0, this.length, value);
            break;
          }
      }
    } // https://dom.spec.whatwg.org/#dom-node-insertbefore

  }, {
    key: "insertBefore",
    value: function insertBefore(nodeImpl, childImpl) {
      return this._preInsert(nodeImpl, childImpl);
    } // https://dom.spec.whatwg.org/#dom-node-appendchild

  }, {
    key: "appendChild",
    value: function appendChild(nodeImpl) {
      return this._append(nodeImpl);
    } // https://dom.spec.whatwg.org/#dom-node-replacechild

  }, {
    key: "replaceChild",
    value: function replaceChild(nodeImpl, childImpl) {
      return this._replace(nodeImpl, childImpl);
    } // https://dom.spec.whatwg.org/#dom-node-removechild

  }, {
    key: "removeChild",
    value: function removeChild(oldChildImpl) {
      return this._preRemove(oldChildImpl);
    } // https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity

  }, {
    key: "_preInsertValidity",
    value: function _preInsertValidity(nodeImpl, childImpl) {
      var nodeType = nodeImpl.nodeType,
          nodeName = nodeImpl.nodeName;
      var parentType = this.nodeType,
          parentName = this.nodeName;

      if (parentType !== NODE_TYPE.DOCUMENT_NODE && parentType !== NODE_TYPE.DOCUMENT_FRAGMENT_NODE && parentType !== NODE_TYPE.ELEMENT_NODE) {
        throw DOMException.create(this._globalObject, ["Node can't be inserted in a ".concat(parentName, " parent."), "HierarchyRequestError"]);
      }

      if (isHostInclusiveAncestor(nodeImpl, this)) {
        throw DOMException.create(this._globalObject, ["The operation would yield an incorrect node tree.", "HierarchyRequestError"]);
      }

      if (childImpl && domSymbolTree.parent(childImpl) !== this) {
        throw DOMException.create(this._globalObject, ["The child can not be found in the parent.", "NotFoundError"]);
      }

      if (nodeType !== NODE_TYPE.DOCUMENT_FRAGMENT_NODE && nodeType !== NODE_TYPE.DOCUMENT_TYPE_NODE && nodeType !== NODE_TYPE.ELEMENT_NODE && nodeType !== NODE_TYPE.TEXT_NODE && nodeType !== NODE_TYPE.CDATA_SECTION_NODE && // CData section extends from Text
      nodeType !== NODE_TYPE.PROCESSING_INSTRUCTION_NODE && nodeType !== NODE_TYPE.COMMENT_NODE) {
        throw DOMException.create(this._globalObject, ["".concat(nodeName, " node can't be inserted in parent node."), "HierarchyRequestError"]);
      }

      if (nodeType === NODE_TYPE.TEXT_NODE && parentType === NODE_TYPE.DOCUMENT_NODE || nodeType === NODE_TYPE.DOCUMENT_TYPE_NODE && parentType !== NODE_TYPE.DOCUMENT_NODE) {
        throw DOMException.create(this._globalObject, ["".concat(nodeName, " node can't be inserted in ").concat(parentName, " parent."), "HierarchyRequestError"]);
      }

      if (parentType === NODE_TYPE.DOCUMENT_NODE) {
        var nodeChildren = domSymbolTree.childrenToArray(nodeImpl);
        var parentChildren = domSymbolTree.childrenToArray(this);

        switch (nodeType) {
          case NODE_TYPE.DOCUMENT_FRAGMENT_NODE:
            {
              var nodeChildrenElements = nodeChildren.filter(function (child) {
                return child.nodeType === NODE_TYPE.ELEMENT_NODE;
              });

              if (nodeChildrenElements.length > 1) {
                throw DOMException.create(this._globalObject, ["Invalid insertion of ".concat(nodeName, " node in ").concat(parentName, " node."), "HierarchyRequestError"]);
              }

              var hasNodeTextChildren = nodeChildren.some(function (child) {
                return child.nodeType === NODE_TYPE.TEXT_NODE;
              });

              if (hasNodeTextChildren) {
                throw DOMException.create(this._globalObject, ["Invalid insertion of ".concat(nodeName, " node in ").concat(parentName, " node."), "HierarchyRequestError"]);
              }

              if (nodeChildrenElements.length === 1 && (parentChildren.some(function (child) {
                return child.nodeType === NODE_TYPE.ELEMENT_NODE;
              }) || childImpl && childImpl.nodeType === NODE_TYPE.DOCUMENT_TYPE_NODE || childImpl && domSymbolTree.nextSibling(childImpl) && domSymbolTree.nextSibling(childImpl).nodeType === NODE_TYPE.DOCUMENT_TYPE_NODE)) {
                throw DOMException.create(this._globalObject, ["Invalid insertion of ".concat(nodeName, " node in ").concat(parentName, " node."), "HierarchyRequestError"]);
              }

              break;
            }

          case NODE_TYPE.ELEMENT_NODE:
            if (parentChildren.some(function (child) {
              return child.nodeType === NODE_TYPE.ELEMENT_NODE;
            }) || childImpl && childImpl.nodeType === NODE_TYPE.DOCUMENT_TYPE_NODE || childImpl && domSymbolTree.nextSibling(childImpl) && domSymbolTree.nextSibling(childImpl).nodeType === NODE_TYPE.DOCUMENT_TYPE_NODE) {
              throw DOMException.create(this._globalObject, ["Invalid insertion of ".concat(nodeName, " node in ").concat(parentName, " node."), "HierarchyRequestError"]);
            }

            break;

          case NODE_TYPE.DOCUMENT_TYPE_NODE:
            if (parentChildren.some(function (child) {
              return child.nodeType === NODE_TYPE.DOCUMENT_TYPE_NODE;
            }) || childImpl && domSymbolTree.previousSibling(childImpl) && domSymbolTree.previousSibling(childImpl).nodeType === NODE_TYPE.ELEMENT_NODE || !childImpl && parentChildren.some(function (child) {
              return child.nodeType === NODE_TYPE.ELEMENT_NODE;
            })) {
              throw DOMException.create(this._globalObject, ["Invalid insertion of ".concat(nodeName, " node in ").concat(parentName, " node."), "HierarchyRequestError"]);
            }

            break;
        }
      }
    } // https://dom.spec.whatwg.org/#concept-node-pre-insert

  }, {
    key: "_preInsert",
    value: function _preInsert(nodeImpl, childImpl) {
      this._preInsertValidity(nodeImpl, childImpl);

      var referenceChildImpl = childImpl;

      if (referenceChildImpl === nodeImpl) {
        referenceChildImpl = domSymbolTree.nextSibling(nodeImpl);
      }

      this._ownerDocument._adoptNode(nodeImpl);

      this._insert(nodeImpl, referenceChildImpl);

      return nodeImpl;
    } // https://dom.spec.whatwg.org/#concept-node-insert

  }, {
    key: "_insert",
    value: function _insert(nodeImpl, childImpl, suppressObservers) {
      var count = nodeImpl.nodeType === NODE_TYPE.DOCUMENT_FRAGMENT_NODE ? domSymbolTree.childrenCount(nodeImpl) : 1;

      if (childImpl) {
        var childIndex = domSymbolTree.index(childImpl);

        var _iterator12 = _createForOfIteratorHelper(this._referencedRanges),
            _step12;

        try {
          for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
            var range = _step12.value;
            var _start = range._start,
                _end = range._end;

            if (_start.offset > childIndex) {
              range._setLiveRangeStart(this, _start.offset + count);
            }

            if (_end.offset > childIndex) {
              range._setLiveRangeEnd(this, _end.offset + count);
            }
          }
        } catch (err) {
          _iterator12.e(err);
        } finally {
          _iterator12.f();
        }
      }

      var nodesImpl = nodeImpl.nodeType === NODE_TYPE.DOCUMENT_FRAGMENT_NODE ? domSymbolTree.childrenToArray(nodeImpl) : [nodeImpl];

      if (nodeImpl.nodeType === NODE_TYPE.DOCUMENT_FRAGMENT_NODE) {
        var grandChildImpl;

        while (grandChildImpl = domSymbolTree.firstChild(nodeImpl)) {
          nodeImpl._remove(grandChildImpl, true);
        }
      }

      if (nodeImpl.nodeType === NODE_TYPE.DOCUMENT_FRAGMENT_NODE) {
        queueTreeMutationRecord(nodeImpl, [], nodesImpl, null, null);
      }

      var previousChildImpl = childImpl ? domSymbolTree.previousSibling(childImpl) : domSymbolTree.lastChild(this);

      var _iterator13 = _createForOfIteratorHelper(nodesImpl),
          _step13;

      try {
        for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
          var node = _step13.value;

          if (!childImpl) {
            domSymbolTree.appendChild(this, node);
          } else {
            domSymbolTree.insertBefore(childImpl, node);
          }

          if (this.nodeType === NODE_TYPE.ELEMENT_NODE && this._shadowRoot !== null && (node.nodeType === NODE_TYPE.ELEMENT_NODE || node.nodeType === NODE_TYPE.TEXT_NODE)) {
            assignSlot(node);
          }

          this._modified();

          if (node.nodeType === NODE_TYPE.TEXT_NODE || node.nodeType === NODE_TYPE.CDATA_SECTION_NODE) {
            this._childTextContentChangeSteps();
          }

          if (isSlot(this) && this._assignedNodes.length === 0 && isShadowRoot(nodeRoot(this))) {
            signalSlotChange(this);
          }

          var root = nodeRoot(node);

          if (isShadowRoot(root)) {
            assignSlotableForTree(root);
          }

          if (this._attached && nodeImpl._attach) {
            node._attach();
          }

          this._descendantAdded(this, node);

          var _iterator14 = _createForOfIteratorHelper(shadowIncludingInclusiveDescendantsIterator(node)),
              _step14;

          try {
            for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
              var inclusiveDescendant = _step14.value;

              if (inclusiveDescendant.isConnected) {
                if (inclusiveDescendant._ceState === "custom") {
                  enqueueCECallbackReaction(inclusiveDescendant, "connectedCallback", []);
                } else {
                  tryUpgradeElement(inclusiveDescendant);
                }
              }
            }
          } catch (err) {
            _iterator14.e(err);
          } finally {
            _iterator14.f();
          }
        }
      } catch (err) {
        _iterator13.e(err);
      } finally {
        _iterator13.f();
      }

      if (!suppressObservers) {
        queueTreeMutationRecord(this, nodesImpl, [], previousChildImpl, childImpl);
      }
    } // https://dom.spec.whatwg.org/#concept-node-append

  }, {
    key: "_append",
    value: function _append(nodeImpl) {
      return this._preInsert(nodeImpl, null);
    } // https://dom.spec.whatwg.org/#concept-node-replace

  }, {
    key: "_replace",
    value: function _replace(nodeImpl, childImpl) {
      var nodeType = nodeImpl.nodeType,
          nodeName = nodeImpl.nodeName;
      var parentType = this.nodeType,
          parentName = this.nodeName; // Note: This section differs from the pre-insert validation algorithm.

      if (parentType !== NODE_TYPE.DOCUMENT_NODE && parentType !== NODE_TYPE.DOCUMENT_FRAGMENT_NODE && parentType !== NODE_TYPE.ELEMENT_NODE) {
        throw DOMException.create(this._globalObject, ["Node can't be inserted in a ".concat(parentName, " parent."), "HierarchyRequestError"]);
      }

      if (isHostInclusiveAncestor(nodeImpl, this)) {
        throw DOMException.create(this._globalObject, ["The operation would yield an incorrect node tree.", "HierarchyRequestError"]);
      }

      if (childImpl && domSymbolTree.parent(childImpl) !== this) {
        throw DOMException.create(this._globalObject, ["The child can not be found in the parent.", "NotFoundError"]);
      }

      if (nodeType !== NODE_TYPE.DOCUMENT_FRAGMENT_NODE && nodeType !== NODE_TYPE.DOCUMENT_TYPE_NODE && nodeType !== NODE_TYPE.ELEMENT_NODE && nodeType !== NODE_TYPE.TEXT_NODE && nodeType !== NODE_TYPE.CDATA_SECTION_NODE && // CData section extends from Text
      nodeType !== NODE_TYPE.PROCESSING_INSTRUCTION_NODE && nodeType !== NODE_TYPE.COMMENT_NODE) {
        throw DOMException.create(this._globalObject, ["".concat(nodeName, " node can't be inserted in parent node."), "HierarchyRequestError"]);
      }

      if (nodeType === NODE_TYPE.TEXT_NODE && parentType === NODE_TYPE.DOCUMENT_NODE || nodeType === NODE_TYPE.DOCUMENT_TYPE_NODE && parentType !== NODE_TYPE.DOCUMENT_NODE) {
        throw DOMException.create(this._globalObject, ["".concat(nodeName, " node can't be inserted in ").concat(parentName, " parent."), "HierarchyRequestError"]);
      }

      if (parentType === NODE_TYPE.DOCUMENT_NODE) {
        var nodeChildren = domSymbolTree.childrenToArray(nodeImpl);
        var parentChildren = domSymbolTree.childrenToArray(this);

        switch (nodeType) {
          case NODE_TYPE.DOCUMENT_FRAGMENT_NODE:
            {
              var nodeChildrenElements = nodeChildren.filter(function (child) {
                return child.nodeType === NODE_TYPE.ELEMENT_NODE;
              });

              if (nodeChildrenElements.length > 1) {
                throw DOMException.create(this._globalObject, ["Invalid insertion of ".concat(nodeName, " node in ").concat(parentName, " node."), "HierarchyRequestError"]);
              }

              var hasNodeTextChildren = nodeChildren.some(function (child) {
                return child.nodeType === NODE_TYPE.TEXT_NODE;
              });

              if (hasNodeTextChildren) {
                throw DOMException.create(this._globalObject, ["Invalid insertion of ".concat(nodeName, " node in ").concat(parentName, " node."), "HierarchyRequestError"]);
              }

              var parentChildElements = parentChildren.filter(function (child) {
                return child.nodeType === NODE_TYPE.ELEMENT_NODE;
              });

              if (nodeChildrenElements.length === 1 && (parentChildElements.length === 1 && parentChildElements[0] !== childImpl || childImpl && domSymbolTree.nextSibling(childImpl) && domSymbolTree.nextSibling(childImpl).nodeType === NODE_TYPE.DOCUMENT_TYPE_NODE)) {
                throw DOMException.create(this._globalObject, ["Invalid insertion of ".concat(nodeName, " node in ").concat(parentName, " node."), "HierarchyRequestError"]);
              }

              break;
            }

          case NODE_TYPE.ELEMENT_NODE:
            if (parentChildren.some(function (child) {
              return child.nodeType === NODE_TYPE.ELEMENT_NODE && child !== childImpl;
            }) || childImpl && domSymbolTree.nextSibling(childImpl) && domSymbolTree.nextSibling(childImpl).nodeType === NODE_TYPE.DOCUMENT_TYPE_NODE) {
              throw DOMException.create(this._globalObject, ["Invalid insertion of ".concat(nodeName, " node in ").concat(parentName, " node."), "HierarchyRequestError"]);
            }

            break;

          case NODE_TYPE.DOCUMENT_TYPE_NODE:
            if (parentChildren.some(function (child) {
              return child.nodeType === NODE_TYPE.DOCUMENT_TYPE_NODE && child !== childImpl;
            }) || childImpl && domSymbolTree.previousSibling(childImpl) && domSymbolTree.previousSibling(childImpl).nodeType === NODE_TYPE.ELEMENT_NODE) {
              throw DOMException.create(this._globalObject, ["Invalid insertion of ".concat(nodeName, " node in ").concat(parentName, " node."), "HierarchyRequestError"]);
            }

            break;
        }
      }

      var referenceChildImpl = domSymbolTree.nextSibling(childImpl);

      if (referenceChildImpl === nodeImpl) {
        referenceChildImpl = domSymbolTree.nextSibling(nodeImpl);
      }

      var previousSiblingImpl = domSymbolTree.previousSibling(childImpl);

      this._ownerDocument._adoptNode(nodeImpl);

      var removedNodesImpl = [];

      if (domSymbolTree.parent(childImpl)) {
        removedNodesImpl = [childImpl];

        this._remove(childImpl, true);
      }

      var nodesImpl = nodeImpl.nodeType === NODE_TYPE.DOCUMENT_FRAGMENT_NODE ? domSymbolTree.childrenToArray(nodeImpl) : [nodeImpl];

      this._insert(nodeImpl, referenceChildImpl, true);

      queueTreeMutationRecord(this, nodesImpl, removedNodesImpl, previousSiblingImpl, referenceChildImpl);
      return childImpl;
    } // https://dom.spec.whatwg.org/#concept-node-replace-all

  }, {
    key: "_replaceAll",
    value: function _replaceAll(nodeImpl) {
      if (nodeImpl !== null) {
        this._ownerDocument._adoptNode(nodeImpl);
      }

      var removedNodesImpl = domSymbolTree.childrenToArray(this);
      var addedNodesImpl;

      if (nodeImpl === null) {
        addedNodesImpl = [];
      } else if (nodeImpl.nodeType === NODE_TYPE.DOCUMENT_FRAGMENT_NODE) {
        addedNodesImpl = domSymbolTree.childrenToArray(nodeImpl);
      } else {
        addedNodesImpl = [nodeImpl];
      }

      var _iterator15 = _createForOfIteratorHelper(domSymbolTree.childrenIterator(this)),
          _step15;

      try {
        for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
          var childImpl = _step15.value;

          this._remove(childImpl, true);
        }
      } catch (err) {
        _iterator15.e(err);
      } finally {
        _iterator15.f();
      }

      if (nodeImpl !== null) {
        this._insert(nodeImpl, null, true);
      }

      if (addedNodesImpl.length > 0 || removedNodesImpl.length > 0) {
        queueTreeMutationRecord(this, addedNodesImpl, removedNodesImpl, null, null);
      }
    } // https://dom.spec.whatwg.org/#concept-node-pre-remove

  }, {
    key: "_preRemove",
    value: function _preRemove(childImpl) {
      if (domSymbolTree.parent(childImpl) !== this) {
        throw DOMException.create(this._globalObject, ["The node to be removed is not a child of this node.", "NotFoundError"]);
      }

      this._remove(childImpl);

      return childImpl;
    } // https://dom.spec.whatwg.org/#concept-node-remove

  }, {
    key: "_remove",
    value: function _remove(nodeImpl, suppressObservers) {
      var index = domSymbolTree.index(nodeImpl);

      var _iterator16 = _createForOfIteratorHelper(domSymbolTree.treeIterator(nodeImpl)),
          _step16;

      try {
        for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
          var descendant = _step16.value;

          var _iterator20 = _createForOfIteratorHelper(descendant._referencedRanges),
              _step20;

          try {
            for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
              var range = _step20.value;
              var _start = range._start,
                  _end = range._end;

              if (_start.node === descendant) {
                range._setLiveRangeStart(this, index);
              }

              if (_end.node === descendant) {
                range._setLiveRangeEnd(this, index);
              }
            }
          } catch (err) {
            _iterator20.e(err);
          } finally {
            _iterator20.f();
          }
        }
      } catch (err) {
        _iterator16.e(err);
      } finally {
        _iterator16.f();
      }

      var _iterator17 = _createForOfIteratorHelper(this._referencedRanges),
          _step17;

      try {
        for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
          var _range = _step17.value;
          var _start2 = _range._start,
              _end2 = _range._end;

          if (_start2.node === this && _start2.offset > index) {
            _range._setLiveRangeStart(this, _start2.offset - 1);
          }

          if (_end2.node === this && _end2.offset > index) {
            _range._setLiveRangeEnd(this, _end2.offset - 1);
          }
        }
      } catch (err) {
        _iterator17.e(err);
      } finally {
        _iterator17.f();
      }

      if (this._ownerDocument) {
        this._ownerDocument._runPreRemovingSteps(nodeImpl);
      }

      var oldPreviousSiblingImpl = domSymbolTree.previousSibling(nodeImpl);
      var oldNextSiblingImpl = domSymbolTree.nextSibling(nodeImpl);
      domSymbolTree.remove(nodeImpl);

      if (nodeImpl._assignedSlot) {
        assignSlotable(nodeImpl._assignedSlot);
      }

      if (isSlot(this) && this._assignedNodes.length === 0 && isShadowRoot(nodeRoot(this))) {
        signalSlotChange(this);
      }

      var hasSlotDescendant = isSlot(nodeImpl);

      if (!hasSlotDescendant) {
        var _iterator18 = _createForOfIteratorHelper(domSymbolTree.treeIterator(nodeImpl)),
            _step18;

        try {
          for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
            var child = _step18.value;

            if (isSlot(child)) {
              hasSlotDescendant = true;
              break;
            }
          }
        } catch (err) {
          _iterator18.e(err);
        } finally {
          _iterator18.f();
        }
      }

      if (hasSlotDescendant) {
        assignSlotableForTree(nodeRoot(this));
        assignSlotableForTree(nodeImpl);
      }

      this._modified();

      nodeImpl._detach();

      this._descendantRemoved(this, nodeImpl);

      if (this.isConnected) {
        if (nodeImpl._ceState === "custom") {
          enqueueCECallbackReaction(nodeImpl, "disconnectedCallback", []);
        }

        var _iterator19 = _createForOfIteratorHelper(shadowIncludingDescendantsIterator(nodeImpl)),
            _step19;

        try {
          for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
            var descendantImpl = _step19.value;

            if (descendantImpl._ceState === "custom") {
              enqueueCECallbackReaction(descendantImpl, "disconnectedCallback", []);
            }
          }
        } catch (err) {
          _iterator19.e(err);
        } finally {
          _iterator19.f();
        }
      }

      if (!suppressObservers) {
        queueTreeMutationRecord(this, [], [nodeImpl], oldPreviousSiblingImpl, oldNextSiblingImpl);
      }

      if (nodeImpl.nodeType === NODE_TYPE.TEXT_NODE) {
        this._childTextContentChangeSteps();
      }
    }
  }]);

  return NodeImpl;
}(EventTargetImpl);

module.exports = {
  implementation: NodeImpl
};